import React from "react";
import Drawer from "react-modern-drawer";

import SettingsDrawerContent from "./SettingsDrawerContent";

type Props = {
  onClose: () => void;
  isOpen: boolean;
};

const SettingsDrawer = ({ isOpen, onClose }: Props) => {
  return (
    <Drawer
      open={isOpen}
      size="100vh"
      onClose={onClose}
      direction="bottom"
      enableOverlay={false}
      style={{ boxShadow: "none", border: "none" }}
    >
      {isOpen && <SettingsDrawerContent />}
    </Drawer>
  );
};

export default SettingsDrawer;
